const en = {
  menu: {
    webContra: 'Contradistinction',
  },
  footer: {
    eMail: 'Email: support@dharma-treasure.org',
    tel: 'Phone: +886-2-27586828',
    address: 'Address: 11051 9F., No.401, Sec. 4, Xinyi Rd., Xinyi Dist., Taipei City 110, Taiwan',
    copyRight: '@2019 Dharma Treasure Corp. Copyright.',
    webTreasure: 'Dharma Treasure',
    webAdarsha: 'Adarsha',
    webToolBox: 'KETAKA',
    webEBook: 'DHARMA EBOOKS',
    webSupport: 'Dharma Treasure Support',
  },
  versions: {
    version: '{noticeType}',
    intro: '{noticeType}',
    type: [
      { text: 'EN德格版' },
      { text: 'EN八十華嚴' },
      { text: 'EN六十華嚴' },
      { text: 'EN求佛' },
      { text: 'EN本業' },
    ],
    bookName: [
      { text: '《藏譯華嚴》EN' },
      { text: '《八十華嚴》EN' },
      { text: '《六⼗華嚴》EN' },
      { text: '《諸菩薩求佛本業經》EN' },
      { text: '《菩薩本業經 • 願⾏品》EN' },
    ],
    introType: [
      { text: 'EN德格版INTRO' },
      { text: 'EN八十華嚴INTRO' },
      { text: 'EN六十華嚴INTRO' },
      { text: 'EN求佛INTRO' },
      { text: 'EN本業INTRO' },
    ],
  },
  sutras: {
    sutra: '{noticeType}',
    intro: '{noticeType}',
    type: [
      { text: 'EN淨行品' },
      { text: 'EN十地品' },
      { text: 'EN賢首菩薩品' },
      { text: 'EN如來光明覺品' },
    ],
    introType: [
      { text: 'EN淨，是清淨，清淨是對著染污而言。要是染污，就是不清淨；清淨，就是不染污。什麼清淨了？身口意三業清淨；什麼不染污了？身口意三業不造惡業，這是沒有染污。如果你身口意染污的話，就是凡夫。那麼說：「二乘人已經得到無漏了，他也是清淨吧？」不是的。二乘無漏是無漏，但是沒有利他的這種德行；因為沒有利他的德行，所以談不到真正的清淨。這個清淨行就是菩薩行，菩薩所修行的。大乘的菩薩既能自利，又能利他；既能自覺，更能覺他，所以他修這個清淨的行門。這種清淨行門，是所有修道人都應該遵照去修行的。' },
      { text: 'EN十地品INTRO' },
      { text: 'EN賢首菩薩品INTRO' },
      { text: 'EN如來光明覺品INTRO' },
    ],
  },
  sutra01: {
    title: '淨行品EN',
  },
  sutra02: {
    title: '十地品EN',
  },
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en/avatamsaka.js